module.exports = __webpack_public_path__ + "static/businesses_3-9336282505b541f7f6de9aa61ad389e9.svg";